import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
    template: `<nb-card style="max-width: 70vh;">
    <nb-card-header>{{ header }}</nb-card-header>
    <nb-card-body>
        <div class="text-center" [innerHTML]="body"></div>
    </nb-card-body>
    <nb-card-footer>
        <button class="btn-float-right" nbButton hero status="default" (click)="closeDialog()">Close</button>
    </nb-card-footer>
    </nb-card>`,
})
export class CommonDialogComponent {
    constructor(protected ref: NbDialogRef<CommonDialogComponent>) { }

    @Input() header: string;
    @Input() body: string;
    closeDialog() {
        this.ref.close();
    }
}